// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"9f204d7d","739":"0ee96342"}[chunkId] + ".chunk.js";
};